module.exports = __webpack_public_path__ + "static/form-remodel-b810385e1dc0000e3fa7b44911442211.jpg";